export default __webpack_public_path__ + "static/char-s-32-zh-Hans-258a7f0265a777afef98afe68a7ccd76.png";